<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Head from '@/components/Head.vue'
import MobileWarning from '@/components/MobileWarning.vue'
import { screenModule } from '@/store/screen/module'

const route = useRoute()

const breakpoint = computed(() => {
    return screenModule.getters.getBreakpoint()
})
</script>

<template>
    <div class="skeleton">
        <div class="skeleton-head__container">
            <Head class="skeleton-head" />
        </div>
        <div class="skeleton-head__mobile-warning">
            <MobileWarning
                v-if="breakpoint === 'black-bear' && route.name !== 'register'"
            />
        </div>
        <div class="skeleton-body">
            <div class="skeleton-body__content">
                <aside class="skeleton-side__container">
                    <slot name="side" />
                </aside>
                <main
                    class="skeleton-front__container">
                    <div class="skeleton-front">
                        <slot />
                    </div>
                </main>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>


.skeleton {
    height: calc(100% - 54px);

    .skeleton-head__container {
        width: 100%;
        background-color: $brand-blue;
        padding: 0 44px;
        box-sizing: border-box;
        top: 0;
        left: 0;
        z-index: 1001;
        position: relative;

        .skeleton-head {
            height: 54px;
        }
    }

    .skeleton-head__mobile-warning {
        z-index: 1001;
    }

    .skeleton-body {
        height: 100%;
        position: relative;
        overflow: auto;

        &__content {
            display: flex;
            min-height: 100%;
        }

        .skeleton-side__container {
            background: $gray-background;
            max-width: 400px;
            width: 100%;
            position: fixed;
            height: 100vh;
            overflow: scroll;
        }

        .skeleton-front__container {
            width: 100%;
            margin-left: 400px;

            .skeleton-front {
                max-width: 790px;
                padding: 40px 44px 80px 44px;
                margin: 0 auto;

                &--content {
                    padding: 40px 44px 0px 44px;
                }
            }
        }
    }
}
</style>
